<template>
    <div class="patrol_management_container">
        <!--searchCont头部-->
        <el-form :inline="true" class="leader-style-form">
            <el-form-item label="巡检负责人">
                <el-input
                    maxlength="50"
                    v-model="searchForm.leader_id_name"
                    autocomplete="off"
                    clearable="true"
                ></el-input>
            </el-form-item>
            <el-form-item label="巡检计划状态">
                <el-select v-model="searchForm.inspection_plan_state">
                    <el-option label="全部" value></el-option>
                    <el-option label="启用" value="0"></el-option>
                    <el-option label="停用" value="1"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="巡检类型">
                <el-select v-model="searchForm.inspection_plan_type">
                    <el-option label="全部" value></el-option>
                    <el-option label="正常巡检" value="10"></el-option>
                    <el-option label="临时巡检" value="20"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="warning" @click="doSearch()">查询</el-button>
                <el-button type="primary" @click="addNewOne('addForm')">增加</el-button>
            </el-form-item>
        </el-form>

        <div class="table-wrap">
            <el-table border :data="tableJson" class="leader-style-table">
                <el-table-column type="index" width="50" align="center" label="序号" property="num"></el-table-column>
                <el-table-column label="巡检计划编号" property="inspection_plan_no" align="center"></el-table-column>
                <el-table-column label="巡检任务负责人" property="leader_id_name" align="center"></el-table-column>
                <el-table-column label="巡检人员" property="worker_names" align="center"></el-table-column>
                <el-table-column label="巡检设备数量" property="tree_count" align="center"></el-table-column>
                <el-table-column label="周期频度" property="interval" align="center"></el-table-column>
                <el-table-column label="巡检周期" property="plan_according_type_name" align="center"></el-table-column>
                <el-table-column label="巡检时间" property="next_time" align="center" width="200px"></el-table-column>
                <el-table-column label="巡检类型" property="inspection_plan_type_name" align="center"></el-table-column>
                <el-table-column
                    label="巡检计划状态"
                    property="inspection_plan_state_name"
                    align="center"
                ></el-table-column>
                <el-table-column label="修改" width="220" align="center">
                    <template slot-scope="scope">
                        <el-button
                            @click="changeItemShow(scope.row)"
                            type="text"
                            class="button-check"
                        >
                            <i class="iconfont iconeditor"></i>
                            <span class="inner-text">修改</span>
                        </el-button>
                        <el-button
                            @click="doChangeState(scope.row, 0)"
                            type="text"
                            class="botton-modify"
                            v-if="scope.row.inspection_plan_state == '1'"
                        >
                            <i class="iconfont iconicon-"></i>
                            <span class="inner-text">启用</span>
                        </el-button>
                        <el-button
                            @click="doChangeState(scope.row, 1)"
                            type="text"
                            class="button-delete"
                            v-else
                        >
                            <i class="iconfont icontingyong"></i>
                            <span class="inner-text">停用</span>
                        </el-button>
                        <el-button
                            @click="deleteItemShow(scope.row)"
                            type="text"
                            class="button-delete"
                        >
                            <i class="iconfont iconashbin"></i>
                            <span class="inner-text">删除</span>
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination
                class="leader-style-pagination"
                :paginationData="paginationData"
                @paginationDataNew="paginationDataNew"
                v-if="this.paginationData.totalNum"
            ></Pagination>
        </div>

        <!--新增dialog-->
        <el-dialog
            class="leader-dialog"
            :title="add_title"
            width="1100px"
            :visible.sync="addshow"
            :close-on-click-modal="false"
        >
            <el-scrollbar style="height: 470px">
                <div class="patrol_dialog_div">
                    <div style="height: 470px; width: 280px">
                        <el-scrollbar style="height: 100%">
                            <div class="tree-wrap">
                                <me-tree
                                    ref="myTree"
                                    :treeData="treeData"
                                    :treeLoading="treeLoading"
                                    :treeToolBar="false"
                                    :defaultProps="defaultProps"
                                    :nodeKey="'tree_id'"
                                    :showCheckbox="true"
                                    :title="''"
                                    :cascadingVar="true"
                                    :defaultExpandedKeys="defaultCheckKeys"
                                    :checkStrictly.sync="checkStrictly"
                                    :isCheckClick="true"
                                    :defaultCheckKeys="defaultCheckKeys"
                                    @handleCheckBoxClick="handleTreeNodeClick"
                                ></me-tree>
                            </div>
                        </el-scrollbar>
                    </div>
                    <div>
                        <div class="table_with_timetag">
                            <el-tag
                                v-for="tag in addForm.companyTags"
                                :key="tag"
                                :closable="canClose"
                                @close="handleRemoveTime(tag)"
                                :disable-transitions="true"
                            >{{ tag }}</el-tag>
                        </div>
                        <el-form
                            class="leader-style-form"
                            :rules="formRules"
                            :model="addForm"
                            ref="addForm"
                            :show-message="false"
                        >
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item
                                        label="巡检任务负责人"
                                        :label-width="formLabelWidth"
                                        prop="leader_id"
                                    >
                                        <el-select v-model="addForm.leader_id">
                                            <el-option
                                                v-for="item in headJson"
                                                :key="item.user_id"
                                                :label="item.user_name"
                                                :value="item.user_id"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item
                                        label="巡检人员"
                                        :label-width="formLabelWidth"
                                        prop="worker_ids"
                                    >
                                        <el-select v-model="addForm.worker_ids" multiple>
                                            <el-option
                                                v-for="item in membersJson"
                                                :key="item.user_id"
                                                :label="item.user_name"
                                                :value="item.user_id"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>

                                <el-col :span="24">
                                    <el-form-item
                                        label="巡检类型"
                                        :label-width="formLabelWidth"
                                        style="width: 100%"
                                        prop="inspection_plan_type"
                                    >
                                        <el-radio-group
                                            v-model="
                                                addForm.inspection_plan_type
                                            "
                                        >
                                            <el-radio label="10" :disabled="disabled">正常巡检</el-radio>
                                            <el-radio label="20" :disabled="disabled">临时巡检</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>

                                <div v-if="addForm.inspection_plan_type == '20'">
                                    <el-col :span="24">
                                        <el-form-item
                                            label="巡检时间"
                                            :label-width="formLabelWidth"
                                            style="width: 100%"
                                            prop="plan_inspection_time"
                                        >
                                            <el-col :span="12">
                                                <el-date-picker
                                                    v-model="
                                                        addForm.plan_inspection_time
                                                    "
                                                    align="right"
                                                    type="datetime"
                                                    :clearable="false"
                                                    placeholder="选择日期"
                                                    value-format="yyyy-MM-dd HH:mm:ss"
                                                    format="yyyy-MM-dd HH:mm:ss"
                                                ></el-date-picker>
                                            </el-col>
                                            <!-- <el-col
                                                :span="10"
                                                style="margin-left: 5px"
                                            >
                                                <el-checkbox
                                                    v-model="addForm.is_immediately_publish"
                                                    >是否立即发布</el-checkbox
                                                >
                                            </el-col>-->
                                        </el-form-item>
                                    </el-col>
                                </div>
                                <div v-if="addForm.inspection_plan_type == '10'">
                                    <el-col :span="24">
                                        <el-form-item
                                            label
                                            :label-width="formLabelWidth"
                                            style="width: 100%"
                                            prop="anhour"
                                        >
                                            <el-row :gutter="20">
                                                <el-col :span="3">
                                                    <el-radio
                                                        v-model="
                                                            addForm.plan_according_type
                                                        "
                                                        label="10"
                                                    >按小时</el-radio>
                                                </el-col>
                                                <el-col :span="5">
                                                    <el-input
                                                        v-model="
                                                            addForm.hourTime
                                                        "
                                                    ></el-input>
                                                </el-col>
                                                <el-col :span="3">&nbsp;&nbsp;小时</el-col>
                                                <el-col :span="4">首次巡检时间</el-col>
                                                <el-col :span="9">
                                                    <el-date-picker
                                                        v-model="
                                                            addForm.hourNext
                                                        "
                                                        align="right"
                                                        type="datetime"
                                                        :clearable="false"
                                                        placeholder="选择日期"
                                                        value-format="yyyy-MM-dd HH:mm:ss"
                                                        format="yyyy-MM-dd HH:mm:ss"
                                                        :picker-options="
                                                            pickerOptions
                                                        "
                                                    ></el-date-picker>
                                                </el-col>
                                            </el-row>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24">
                                        <el-form-item
                                            label
                                            :label-width="formLabelWidth"
                                            style="width: 100%"
                                            prop="antian"
                                        >
                                            <el-row :gutter="20">
                                                <el-col :span="3">
                                                    <el-radio
                                                        v-model="
                                                            addForm.plan_according_type
                                                        "
                                                        label="20"
                                                    >按天</el-radio>
                                                </el-col>
                                                <el-col :span="5">
                                                    <el-input
                                                        v-model="
                                                            addForm.dayTime
                                                        "
                                                    ></el-input>
                                                </el-col>
                                                <el-col :span="3">&nbsp;&nbsp;天</el-col>
                                                <el-col :span="4">首次巡检时间</el-col>
                                                <el-col :span="9">
                                                    <el-date-picker
                                                        v-model="
                                                            addForm.dayNext
                                                        "
                                                        align="right"
                                                        type="datetime"
                                                        :clearable="false"
                                                        placeholder="选择日期"
                                                        value-format="yyyy-MM-dd HH:mm:ss"
                                                        format="yyyy-MM-dd HH:mm:ss"
                                                        :picker-options="
                                                            pickerOptions
                                                        "
                                                    ></el-date-picker>
                                                </el-col>
                                            </el-row>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24">
                                        <el-form-item
                                            label
                                            :label-width="formLabelWidth"
                                            style="width: 100%"
                                            prop="anzhou"
                                        >
                                            <el-row :gutter="20">
                                                <el-col :span="3">
                                                    <el-radio
                                                        v-model="
                                                            addForm.plan_according_type
                                                        "
                                                        label="30"
                                                    >按周</el-radio>
                                                </el-col>
                                                <el-col :span="5">
                                                    <el-input
                                                        v-model="
                                                            addForm.weekTime
                                                        "
                                                    ></el-input>
                                                </el-col>
                                                <el-col :span="3">&nbsp;&nbsp;周</el-col>
                                                <el-col :span="4">首次巡检时间</el-col>
                                                <el-col :span="9">
                                                    <el-date-picker
                                                        v-model="
                                                            addForm.weekNext
                                                        "
                                                        align="right"
                                                        type="datetime"
                                                        :clearable="false"
                                                        placeholder="选择日期"
                                                        value-format="yyyy-MM-dd HH:mm:ss"
                                                        format="yyyy-MM-dd HH:mm:ss"
                                                        :picker-options="
                                                            pickerOptions
                                                        "
                                                    ></el-date-picker>
                                                </el-col>
                                            </el-row>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="24">
                                        <el-form-item
                                            label
                                            :label-width="formLabelWidth"
                                            style="width: 100%"
                                            prop="anyue"
                                        >
                                            <el-row :gutter="20">
                                                <el-col :span="3">
                                                    <el-radio
                                                        v-model="
                                                            addForm.plan_according_type
                                                        "
                                                        label="40"
                                                    >按月</el-radio>
                                                </el-col>
                                                <el-col :span="5">
                                                    <el-input
                                                        v-model="
                                                            addForm.monthTime
                                                        "
                                                    ></el-input>
                                                </el-col>
                                                <el-col :span="3">&nbsp;&nbsp;月</el-col>
                                                <el-col :span="4">首次巡检时间</el-col>
                                                <el-col :span="9">
                                                    <el-date-picker
                                                        v-model="
                                                            addForm.monthNext
                                                        "
                                                        align="right"
                                                        type="datetime"
                                                        :clearable="false"
                                                        placeholder="选择日期"
                                                        value-format="yyyy-MM-dd HH:mm:ss"
                                                        format="yyyy-MM-dd HH:mm:ss"
                                                        :picker-options="
                                                            pickerOptions
                                                        "
                                                    ></el-date-picker>
                                                </el-col>
                                            </el-row>
                                        </el-form-item>
                                    </el-col>
                                </div>
                                <el-col :span="24">
                                    <el-form-item
                                        label="备注"
                                        :label-width="formLabelWidth"
                                        style="width: 100%"
                                        prop="remark"
                                    >
                                        <el-input
                                            type="textarea"
                                            v-model="addForm.remark"
                                            resize="none"
                                            rows="2"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                </div>
            </el-scrollbar>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addshow = false" class="leader-common-button">取消</el-button>
                <el-button
                    class="leader-common-button"
                    @click="addcommit('addForm')"
                    :loading="this.$store.state.btnType"
                >保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Pagination from '@/comon/components/pagination.vue';
import Tree from '@/comon/components/tree.vue';
import * as api from '../api/index';
export default {
    name: 'Main',
    components: {
        'me-tree': Tree,
        Pagination,
    },
    data() {
        return {
            treeData: [],
            treeLoading: false,
            defaultProps: {
                children: 'childList',
                label: 'tree_name',
            },
            checkStrictly: true,
            tableJson: [],
            searchForm: {
                leader_id_name: '',
                inspection_plan_state: '',
                inspection_plan_type: '',
            },
            formLabelWidth: '140px',
            isEdit: '0', //是否修改状态
            disabled: false,
            add_title: '新增巡检计划',
            addForm: {
                inspection_plan_id: '',
                leader_id: '',
                worker_ids: [],
                remark: '',
                inspection_plan_type: '10', //正常=10  临时=20
                plan_according_type: '10', //按小时=10   按天=20   按轴=30  按月=40
                is_immediately_publish: '0', //是否立即发布
                plan_inspection_time: '', //临时巡检时间
                hourTime: '',
                hourNext: '',
                dayTime: '',
                dayNext: '',
                weekTime: '',
                weekNext: '',
                monthTime: '',
                monthNext: '',
                companyTags: [],
                companyTreeIds: [],
            },
            headJson: [],
            membersJson: [],
            addshow: false,
            formRules: {
                leader_id: [
                    {
                        required: true,
                        trigger: 'change',
                    },
                ],
                worker_ids: [
                    {
                        required: true,
                        trigger: 'change',
                    },
                ],
                // plan_inspection_time: [
                //     {
                //         required: true,
                //         trigger: "change",
                //     },
                // ],
            },
            // 分页器数据
            paginationData: {
                pageNum: 1,
                pageSize: 10,
                totalNum: '',
            },
        };
    },
    mounted() {
        this.getTable();
        this.getMembers();
        this.getUnitPointList();
    },
    methods: {
        /**
         * 获取采集点信息
         */
        getUnitPointList() {
            this.treeLoading = true;
            api.getUnitDocTreeList().then((res) => {
                if (res) {
                    this.treeData = res.bus_json;
                    // if(this.currentTreeNode && this.currentTreeNode.tree_id) {
                    //     this.$nextTick(()=>{
                    //        this.$refs.myTree.$refs.tree.setCurrentNode(this.currentTreeNode);
                    //     })
                    // } else {
                    //     this.$nextTick(()=>{
                    //        this.$refs.myTree.$refs.tree.setCurrentNode(this.treeList[0]);
                    //        this.handleTreeNodeClick(this.treeList[0]);
                    //     })
                    // }
                }
                this.treeLoading = false;
            });
        },
        addNewOne(formName) {
            this.isEdit = '0';
            this.disabled = false;
            this.addshow = true;
            this.clearForm();
        },
        clearForm() {
            this.addForm.plan_according_type = '10';
            this.addForm.inspection_plan_id = '';
            this.addForm.hourTime = '';
            this.addForm.hourNext = '';
            this.addForm.dayTime = '';
            this.addForm.dayNext = '';
            this.addForm.weekTime = '';
            this.addForm.weekNext = '';
            this.addForm.monthTime = '';
            this.addForm.monthNext = '';
            this.addForm.temporaryTime = '';
            this.addForm.xjType = '1';
            this.addForm.companyTags = [];
            this.addForm.companyTreeIds = [];
            this.addForm.remark = '';
            this.step = '1';
            this.$nextTick(() => {
                this.$refs['addForm'].resetFields();
                this.$refs.myTree.$refs.tree.setCheckedNodes([]);
                // this.$refs.myTree.$refs.tree.setCurrentNode("");
            });
        },
        changeItemShow(row) {
            const param = {};
            this.isEdit = '1';
            this.disabled = true;
            this.addshow = true;
            this.clearForm();
            api.selectPlanInfo({
                inspection_plan_id: row.inspection_plan_id,
            }).then((res) => {
                if (res && res.error_code == '0') {
                    const data = res.bus_json;
                    this.addForm.inspection_plan_id = data.inspection_plan_id;
                    this.addForm.leader_id = data.leader_id;
                    this.addForm.worker_ids = [...data.worker_ids.split(',')];
                    this.addForm.remark = data.remark;
                    this.addForm.inspection_plan_type =
                        data.inspection_plan_type;
                    const tree_ids_arr = data.tree_ids.split(',');
                    this.addForm.companyTreeIds = [...tree_ids_arr];
                    this.$nextTick(() => {
                        this.$refs.myTree.$refs.tree.setCheckedKeys(
                            this.addForm.companyTreeIds
                        );
                        const checkedNodes = this.$refs.myTree.$refs.tree.getCheckedNodes();
                        checkedNodes.forEach((item) => {
                            this.addForm.companyTags.push(item.tree_name);
                        });
                    });
                    if (data.inspection_plan_type == '10') {
                        //正常巡检
                        this.addForm.plan_according_type =
                            data.plan_according_type;
                        if (data.plan_according_type == '10') {
                            //按小时
                            this.addForm.hourTime = data.interval;
                            this.addForm.hourNext = data.first_time;
                        } else if (data.plan_according_type == '20') {
                            //按天
                            this.addForm.dayTime = data.interval;
                            this.addForm.dayNext = data.first_time;
                        } else if (data.plan_according_type == '30') {
                            //按周
                            this.addForm.weekTime = data.interval;
                            this.addForm.weekNext = data.first_time;
                        } else if (data.plan_according_type == '40') {
                            //按月
                            this.addForm.monthTime = data.interval;
                            this.addForm.monthNext = data.first_time;
                        }
                    } else {
                        this.addForm.plan_inspection_time =
                            data.plan_inspection_time;
                    }
                }
            });
        },
        doChangeState(row, state) {
            let title = '确认启用该巡检计划？';
            if (state == 1) title = '确认停用该巡检计划？';
            this.$confirm(title, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
                .then(() => {
                    const param = {
                        inspection_plan_state: state,
                        inspection_plan_id: row.inspection_plan_id,
                    };
                    api.updatePlanState(param).then((res) => {
                        if (res) {
                            this.getTable();
                        }
                    });
                })
                .catch(() => { });
        },
        handleTreeNodeClick(select) {
            const index = this.addForm.companyTags.indexOf(select.tree_name);
            if (index == -1) {
                this.addForm.companyTags.push(select.tree_name);
                this.addForm.companyTreeIds.push(select.tree_id);
            } else {
                this.addForm.companyTags.splice(index, 1);
                this.addForm.companyTreeIds.splice(index, 1);
            }
        },
        // handleTreeNodeClickTwo(select) {
        //     const index = this.addForm.shebeiTags.indexOf(
        //         select.tree_unit_name
        //     );
        //     if (index == -1) {
        //         this.addForm.shebeiTags.push(select.tree_unit_name);
        //     } else {
        //         this.addForm.shebeiTags.splice(index, 1);
        //     }
        // },
        addcommit(formName) {
            // this.$store.commit("btnTypeTrue");
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (
                        !this.addForm.companyTreeIds ||
                        !this.addForm.companyTreeIds.length
                    ) {
                        this.$message({
                            type: 'info',
                            message: '请选择设备',
                        });
                        return false;
                    }
                    let worker_ids_str = '';
                    this.addForm.worker_ids.forEach((item) => {
                        worker_ids_str += item + ',';
                    });
                    let param = {};
                    if (this.addForm.inspection_plan_type == '10') {
                        //正常巡检
                        let interval = '';
                        let first_time = '';
                        if (this.addForm.plan_according_type == '10') {
                            //按小时
                            interval = this.addForm.hourTime;
                            first_time = this.addForm.hourNext;
                        } else if (this.addForm.plan_according_type == '20') {
                            //按日
                            interval = this.addForm.dayTime;
                            first_time = this.addForm.dayNext;
                        } else if (this.addForm.plan_according_type == '30') {
                            //按周
                            interval = this.addForm.weekTime;
                            first_time = this.addForm.weekNext;
                        } else if (this.addForm.plan_according_type == '40') {
                            //按月
                            interval = this.addForm.monthTime;
                            first_time = this.addForm.monthNext;
                        }
                        if (!interval || !first_time) {
                            this.$message({
                                type: 'info',
                                message: '请选择巡检周期和巡检时间',
                            });
                            return false;
                        } else {
                            let regNumber = /^\+?[1-9][0-9]*$/;
                            if (regNumber.test(interval) == false) {
                                this.$message({
                                    type: 'info',
                                    message: '巡检周期请输入大于0的正整数',
                                });
                                return false;
                            }
                        }
                        param = {
                            leader_id: this.addForm.leader_id,
                            inspection_plan_type: this.addForm
                                .inspection_plan_type,
                            plan_according_type: this.addForm
                                .plan_according_type,
                            interval: interval,
                            first_time: first_time,
                            tree_id_list: this.addForm.companyTreeIds,
                            worker_ids: worker_ids_str.substring(
                                0,
                                worker_ids_str.length - 1
                            ),
                            remark: this.addForm.remark,
                        };
                    } else {
                        if (!this.addForm.plan_inspection_time) {
                            this.$message({
                                type: 'info',
                                message: '请选择临时巡检时间',
                            });
                            return false;
                        }
                        param = {
                            leader_id: this.addForm.leader_id,
                            inspection_plan_type: this.addForm
                                .inspection_plan_type,
                            plan_according_type: null,
                            plan_inspection_time: this.addForm
                                .plan_inspection_time,
                            tree_id_list: this.addForm.companyTreeIds,
                            worker_ids: worker_ids_str.substring(
                                0,
                                worker_ids_str.length - 1
                            ),
                            remark: this.addForm.remark,
                        };
                    }
                    if (this.isEdit == '1') {
                        param.inspection_plan_id = this.addForm.inspection_plan_id;
                        api.updatePlanInfo(param).then((res) => {
                            if (res && res.error_code == '0') {
                                this.addshow = false;
                                this.getTable();
                            }
                        });
                    } else {
                        api.insertPlanInfo(param).then((res) => {
                            if (res && res.error_code == '0') {
                                this.addshow = false;
                                this.getTable();
                            }
                        });
                    }
                } else {
                    return false;
                }
            });
        },
        getMembers() {
            this.$axios
                .post(
                    '/operation/group/getGroupUsers',
                    {},
                    {
                        headers: {
                            token: window.localStorage.getItem('token'),
                            "Content-Type": "application/json"
                        },
                    }
                )
                .then((res) => {
                    if (res.data.error_code == 0) {

                        this.headJson = res.data.bus_json;
                        this.membersJson = res.data.bus_json;
                        // this.common.setToken(res.data.token);
                    } else if (res.error_code == -1) {
                        this.$router.push({
                            path: '/login',
                        });
                        // const h = this.$createElement;
                        // this.$notify({
                        //     title: '提示',
                        //     message: h(
                        //         'i',
                        //         { style: 'color: teal' },
                        //         res.error_msg
                        //     ),
                        // });
                    } else {
                        // const h = this.$createElement;
                        // this.$notify({
                        //     title: '提示',
                        //     message: h(
                        //         'i',
                        //         { style: 'color: teal' },
                        //         res.error_msg
                        //     ),
                        // });
                    }
                });
        },
        doSearch() {
            this.getTable();
        },
        getTable() {
            const param = {
                ...this.searchForm,
                pageNum: this.paginationData.pageNum,
                pageSize: this.paginationData.pageSize,
            };
            api.selectPlanInfoListByPage(param).then((res) => {
                if (res) {
                    this.tableJson = res.bus_json.items;
                    this.paginationData.pageNum = res.bus_json.pageNum;
                    this.paginationData.pageSize = res.bus_json.pageSize;
                    this.paginationData.totalNum = res.bus_json.totalNum;
                }
            });
        },
        deleteItemShow(row) {
            this.$confirm('确认删除该数据?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            })
                .then(() => {
                    api.deletePlanInfo({
                        inspection_plan_id: row.inspection_plan_id,
                    }).then((res) => {
                        if (res && res.error_code == '0') {
                            this.getTable();
                        }
                    });
                })
                .catch(() => { });
        },
        paginationDataNew(sth) {
            this.paginationData = sth;
            this.getTable();
        },
    },
};
</script>

<style lang="scss" scoped>
.patrol_management_container {
    width: 100%;
    height: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    .table-wrap {
        width: 100%;
        height: 700px;
    }
    .patrol_dialog_div {
        display: flex;
        height: 100%;
        .table_with_timetag {
            flex: 1;
            //  overflow-x: auto;
            display: flex;
            flex-flow: row wrap;
            border-spacing: 5px;
            width: 630px;
            margin: 0 0 5px 0;
            .el-tag {
                margin-left: 5px;
                color: #56fcff;
                background-color: #083472;
                border-color: #56fcff;
                display: table-cell !important;
                margin-bottom: 5px;
            }
            .el-tag .el-tag__close {
                color: #56fcff;
            }
        }
        .patrol_form {
            // color: #fff !important;
            // @include font_color;
            .el-checkbox {
                color: #fff !important;
            }
        }
        .patrol_step_two {
            height: 470px;
            width: 100%;
            display: flex;
            flex-flow: row wrap;
            .patrol_two_shebei {
                border: 1px solid #56fcff;
                color: #56fcff;
                padding: 10px;
                margin: 10px;
                width: fit-content;
                height: fit-content;
                border-radius: 2px;
            }
        }
    }

    .leader-dialog .el-form-item {
        margin-bottom: 10px !important;
    }
    .leader-common-button {
        width: auto;
    }
    .el-radio {
        color: #fff;
    }
}
</style>
